import axios from "axios";
const { VITE_API_URL } = import.meta.env;

const client = axios.create({
  baseURL: VITE_API_URL,
});

export interface ErrorDetail {
  loc: string[]; // Location of the error in the request
  msg: string; // Error message
}

export interface ErrorType {
  response?: {
    data?: {
      detail?: string | ErrorDetail[]; // Supports both string and array formats
    };
  };
}

// LOGIN
export async function loginUser(
  email: string,
  password: string,
  website_url: string,
  fcm_token: string
) {
  try {
    const response = await client.post(
      "login",
      { email, password, website_url, fcm_token },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response;
  } catch (error) {
    const err = error as ErrorType;

    let errorMessage: string;

    if (Array.isArray(err.response?.data?.detail)) {
      // Extract field names and messages
      errorMessage = err.response?.data?.detail
        .map((d) => `${d.loc.slice(-1)[0]}: ${d.msg}`)
        .join("; ");
    } else if (typeof err.response?.data?.detail === "string") {
      errorMessage = err.response?.data?.detail;
    } else {
      errorMessage = "Something went wrong";
    }

    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage);
  }
}
// LOGOUT
export async function logoutUser(token: string, fcm_token: string) {
  try {
    const response = await client.post(
      "logout",
      { fcm_token },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response;
  } catch (error) {
    const err = error as ErrorType;

    let errorMessage: string;

    if (Array.isArray(err.response?.data?.detail)) {
      // Extract field names and messages
      errorMessage = err.response?.data?.detail
        .map((d) => `${d.loc.slice(-1)[0]}: ${d.msg}`)
        .join("; ");
    } else if (typeof err.response?.data?.detail === "string") {
      errorMessage = err.response?.data?.detail;
    } else {
      errorMessage = "Something went wrong";
    }

    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage);
  }
}

// USER RESOURCE LIST
export async function getUserResource(role_id: number, token: string) {
  try {
    const response = await client.get(`role/${role_id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response;
  } catch (error) {
    const err = error as ErrorType;

    let errorMessage: string;

    if (Array.isArray(err.response?.data?.detail)) {
      // Extract field names and messages
      errorMessage = err.response?.data?.detail
        .map((d) => `${d.loc.slice(-1)[0]}: ${d.msg}`)
        .join("; ");
    } else if (typeof err.response?.data?.detail === "string") {
      errorMessage = err.response?.data?.detail;
    } else {
      errorMessage = "Something went wrong";
    }

    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage);
  }
}

// CLOSE COUNTER
export async function closeCounter(counter_id: number, token: string) {
  try {
    const response = await client.put(
      `/pos/counters/${counter_id}`,
      { id: counter_id, is_open: false },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response;
  } catch (error) {
    const err = error as ErrorType;

    let errorMessage: string;

    if (Array.isArray(err.response?.data?.detail)) {
      // Extract field names and messages
      errorMessage = err.response?.data?.detail
        .map((d) => `${d.loc.slice(-1)[0]}: ${d.msg}`)
        .join("; ");
    } else if (typeof err.response?.data?.detail === "string") {
      errorMessage = err.response?.data?.detail;
    } else {
      errorMessage = "Something went wrong";
    }

    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage);
  }
}
